




































































import Swal from 'sweetalert2';
import Vue from 'vue';

import { Aprovacao, aprovacao_repository, StatusAprovacao } from '../../../../store/livro-digital/aprovacoes-respotiroy';
import AprovacaoComponente from './Aprovacao.vue';

interface iData {
    aprovacoes: Aprovacao[]
    loading: boolean
    enviando: boolean
    status_aprovacao: StatusAprovacao
    ressalva: string
}

export default Vue.extend({
    props: {
        ano: {
            type: Number,
            required: true
        },
        mes: {
            type: Number,
            required: true
        },
        codigo_condominio: {
            type: Number,
            required: true
        }
    },
    components: {
        Aprovacao: AprovacaoComponente
    },
    computed: {
        show_form_aprovacao() {
            if (this.relacao.tipoRelacao == 'P') {
                return false;
            }
            if (this.status_atual == 'Aprovado') {
                return false;
            }

            const codigo = this.$store.state.cliente.codigo;
            const codigos = this.aprovacoes.map(({ CodCliente }) => CodCliente)
            

            if (!codigos.includes(codigo)) {
                return false
            }

            return true
        },
        status_atual() {
            let aprovacao = this.aprovacoes.find(a => a.CodCliente == this.$store.state.cliente.codigo)
            if (aprovacao) {
                return aprovacao.Status
            }
            return StatusAprovacao.PENDENTE
        },
        relacao() {
            return this.$store.getters.relacao;
        }
    },
    data(): iData {
        return {
            loading: false,
            enviando: false,
            aprovacoes: [],
            status_aprovacao: StatusAprovacao.PENDENTE,
            ressalva: ''
        }
    },
    methods: {
        async load() {
            try {
                this.loading = true
                this.aprovacoes = []
                this.aprovacoes = await aprovacao_repository.lista({
                    Ano: this.ano,
                    Mes: this.mes,
                    CodCondominio: this.codigo_condominio
                })
            } catch (error) {
                console.error(error)
            } finally {
                this.loading = false
            }
        },
        updateStatusAprovacao() {
            const codigo_cliente = Number(this.$store.state.cliente.codigo)
            let aprovacao = this.aprovacoes.find(aprovacao => aprovacao.CodCliente === codigo_cliente)
            if (aprovacao) {
                this.status_aprovacao = aprovacao.Status
                this.ressalva = aprovacao.Ressalva                
            }
        },
        async sendStatusAprovacao() {
            try {
                const CodCondominio = this.codigo_condominio
                const Ano = this.ano
                const Mes = this.mes
                const Status = this.status_aprovacao
                const Ressalva = [StatusAprovacao.APROVADO_COM_RESSALVA,StatusAprovacao.REPROVADO].includes(Status) ? this.ressalva : ''

                this.enviando = true
                await aprovacao_repository.incluir({
                    CodCondominio,
                    Ano,
                    Mes,
                    Status,
                    Ressalva
                })    
                Swal.fire({
                    icon: "success",
                    title: "Formulário enviado com sucesso"
                })
                this.load()
            } catch (error: any) {
                const text = error?.response?.data?.error || error?.message || "Não foi possível enviar o formulário"

                Swal.fire({
                    icon: "error",
                    title: "Oops",
                    text
                })

            } finally {
                this.enviando = false
            }

        }
    },
    watch: {
        ano: {
            handler() {
                this.load()
            }
        },
        mes: {
            immediate: true,
            handler() {
                this.load()
            }
        },
        aprovacoes: {
            immediate: true,
            handler() {
                this.updateStatusAprovacao()
            }
        }
    }
})

